import type { SUSAddress } from '@/models/sus.type';
import { Stack, Text } from '@mantine/core';

type Props = {
  address: SUSAddress;
};

const joinParts = (...parts: (string | null | undefined)[]): string =>
  parts
    .map(part => part?.trim())
    .filter(Boolean)
    .join(' ');

/** Adresse postale : « n° type nom de voie », lieu-dit, puis « code postal - commune ». */
const SusAddress = ({
  address: { adr_num_voie, adr_type_voie, adr_nom_voie, adr_lieudit, adr_code_postal, adr_commune },
}: Props) => {
  const street = joinParts(adr_num_voie, adr_type_voie, adr_nom_voie);
  const city = [adr_code_postal?.trim(), adr_commune?.trim()].filter(Boolean).join(' - ');
  const lines = [street, adr_lieudit?.trim(), city].filter((line): line is string => !!line);

  if (!lines.length) return <Text>—</Text>;

  return (
    <Stack gap={0} component="address" style={{ fontStyle: 'normal' }}>
      {lines.map(line => (
        <Text key={line}>{line}</Text>
      ))}
    </Stack>
  );
};

export default SusAddress;
